import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import RecipeList from './pages/RecipeList';
import Activities from './pages/Activities';
import Blog from './pages/Blog';
import RecipeDetails from './pages/RecipeDetails';
import ActivityDetail from './pages/ActivityDetail';
import About from './pages/About';
import ResearchPapers from './pages/ResearchPapers';
import OpenSource from './pages/OpenSource';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}> 
          <Route index element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:id" element={<ProjectDetails />} />
          <Route path="research-papers" element={<ResearchPapers />} />
          <Route path="open-source" element={<OpenSource />} />

          {/* Blog parent with nested children */}
          <Route path="blog" element={<Blog />}>
            <Route index element={<RecipeList />} />
            <Route path="recipes" element={<RecipeList />} />
            <Route path="activities" element={<Activities />} />
          </Route>

          {/* fallback standalone routes (kept for compatibility) */}
          <Route path="recipes" element={<RecipeList />} />
          <Route path="recipes/:id" element={<RecipeDetails />} />
          <Route path="activities" element={<Activities />} />
          <Route path="blog/activities/:id" element={<ActivityDetail />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
